exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bci[data-v-edf4cabc]{border:1px solid #ddd}", ""]);

// exports
